/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InquiryDto } from '../../models/inquiry-dto';
import { UpdateInquiryDto } from '../../models/update-inquiry-dto';

export interface InquiryControllerUpdate$Params {
  id: string;
      body: UpdateInquiryDto
}

export function inquiryControllerUpdate(http: HttpClient, rootUrl: string, params: InquiryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<InquiryDto>> {
  const rb = new RequestBuilder(rootUrl, inquiryControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InquiryDto>;
    })
  );
}

inquiryControllerUpdate.PATH = '/api/v1/inquiry/{id}';
